import React, { FC } from 'react'

import { useTranslation } from '@Globals/Translations'

import styles from './SearchResults.module.scss'

interface SearchResultsHeaderProps {
  page: number
  pages: number
  query: string
  totalHits: number
}

const SearchResultsHeader: FC<SearchResultsHeaderProps> = ({ page, pages, query, totalHits }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <h1>
        &quot;
        {query}
        &quot;
      </h1>

      <p>
        {totalHits === 0 && t('header:NO_PRODUCTS_TO_SHOW')}
        {totalHits === 1 && t('header:ONE_PRODUCT_FOUND')}
        {totalHits > 1 && t('header:MORE_THAN_ONE_PRODUCTS_FOUND', { arg1: totalHits })}
        {pages > 1 && (
          <>
            {' - '}
            {t('header:PAGE_X_OF_Y', { arg1: page, arg2: pages })}
          </>
        )}
      </p>
    </div>
  )
}

export default SearchResultsHeader
